import {getCurrentYear} from '../../utils/commons'
import BestMobilePicksLogo from './logo'
import {bestMobilePicksStylesUS} from './styles'

const baseConfig = {
  domainName: 'bestmobilepicks' as const,
  domainType: 'picks' as const,
  siteName: 'Best Mobile Picks',
  favicon: '/favicons/bestmobilepicks.png',
}

const localeConfigs = {
  us: {
    measurementId: 'G-ZFLCTJD5EB',
    camelCaseUrl: 'BestMobilePicks.com',
    logo: <BestMobilePicksLogo locale="us" />,
    title: (_category: string, count: string) =>
      `Top-Rated ${count} of ${getCurrentYear()} | Expert Reviews & Guides | Bestmobilepicks.com`,
    description: (_category?: string, _count?: string) =>
      `Discover the best mobile essentials and comprehensive reviews at Bestmobilepicks.com. Find the most recommended mobile phones, devices, and accessories based on expert and user insights.`,
    styles: bestMobilePicksStylesUS,
  },
}

export const createConfig = (locale: string = 'us') => {
  const localeConfig = localeConfigs[locale as keyof typeof localeConfigs] || localeConfigs.us
  return {
    ...baseConfig,
    ...localeConfig,
  }
}
